import { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import useFeature from './featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES, LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODE_HIDDEN_VIEWS } from '@silverfort-nodelibs/common/utils/system-mode-config';

export const useTabs = (category, visibleFields) => {
    const location = useLocation();
    const history = useHistory();
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const hiddenTabsBySystemMode = SYSTEM_MODE_HIDDEN_VIEWS[LAYOUT_TABS.SYSTEM_SETUP.ID][systemMode]?.tabs;
    const hash = useMemo(() => {
        if (location.hash) {
            const selectedTab = location.hash.split('#')[1];
            const shouldDisplayTabInCurrentSystemMode = !hiddenTabsBySystemMode?.has(selectedTab);
            if (shouldDisplayTabInCurrentSystemMode) {
                return selectedTab;
            }
        }
        return null;
    }, [location.hash, hiddenTabsBySystemMode]);
    const [selectedTab, setSelectedTab] = useState(hash);
    const [lastHistoryURI, setLastHistoryURI] = useState('');

    useEffect(() => {
        if (!selectedTab || hash !== selectedTab || !visibleFields[selectedTab]) {
            const availableTabs =
                Object.values(visibleFields)?.filter((tab) => !hiddenTabsBySystemMode?.has(tab.id)) || [];
            if (availableTabs.length === 0) {
                if (selectedTab !== null) {
                    setSelectedTab(null);
                }
            } else {
                let newTab = availableTabs[0].id;
                if (category.SORT_TABS) {
                    newTab = availableTabs.sort((first, second) => {
                        return first.name > second.name ? 1 : -1;
                    })[0].id;
                }
                if (availableTabs.find((t) => t.id === hash)) {
                    newTab = hash;
                }
                const newHistoryURI = `/Settings/${category.NAME}#${newTab}`;
                if (newHistoryURI !== lastHistoryURI) {
                    setLastHistoryURI(newHistoryURI);
                    history.replace(newHistoryURI);
                }
                if (newTab !== selectedTab) {
                    setSelectedTab(newTab);
                }
            }
        }
    }, [history, category, visibleFields, selectedTab, hash, lastHistoryURI, hiddenTabsBySystemMode]);

    return [selectedTab, setSelectedTab];
};
